import type { ConnectSlot } from "./resolveConnectSlot";

/**
 * Chat 连接入口状态（EDG-591）。单独成文件：ChatContent 只依赖类型与埋点工具，
 * 不应把 useChatConnectEntry 背后的查询 / API 客户端整条依赖链带进来。
 */
export interface ChatConnectEntryState {
  /** 起步清单 invest_account || banking_account；未返回为 undefined，失败 / 超时为 true */
  hasAccountData: boolean | undefined;
  /** 至少一个 Plaid 连接；失败为 true（不出 Connect 项） */
  hasPlaidLink: boolean | undefined;
  /** 推荐问题第 1 张要数据槽；null = 不插槽 */
  slot: ConnectSlot | null;
  markSlotExposed: () => void;
  markSlotClicked: () => void;
}

/** 埋点公共维度（connect_entry_*，全小写 key、字符串值） */
export const buildConnectEntryTrackingParams = (
  state: Pick<ChatConnectEntryState, "hasAccountData" | "hasPlaidLink">,
): Record<string, string> => ({
  has_account_data: String(state.hasAccountData ?? true),
  has_plaid_link: String(state.hasPlaidLink ?? true),
});
